import * as React from "react";

/** Refresh the EPIC access token via the auth dialog. Returns the new token. */
export type RefreshSession = () => Promise<string>;

export interface SessionInfo {
  username: string;
  accessToken: string;
  /**
   * Microsoft Graph access token used to fetch SharePoint headshot
   * thumbnails directly from Graph. May be null if Graph token
   * acquisition failed at sign-in time (consent missing, network, etc).
   * Consumers must tolerate null and fall back gracefully.
   */
  graphAccessToken: string | null;
  /**
   * Re-open the auth dialog and silently refresh both EPIC and Graph
   * tokens (no user interaction unless MSAL's refresh token has also
   * expired). API call sites pass this into `epicQuery` so 401s
   * trigger a transparent refresh + retry.
   */
  refreshSession: RefreshSession;
}

export const SessionContext = React.createContext<SessionInfo | null>(null);

export function useSession(): SessionInfo | null {
  return React.useContext(SessionContext);
}

/** Throws if called outside an authenticated session. */
export function useRequiredSession(): SessionInfo {
  const s = useSession();
  if (!s) throw new Error("useRequiredSession called without a session");
  return s;
}
